import React, { useEffect, useRef, useState } from 'react'
import { ContainerFertilizante } from './styles'
import ViewPage from '../../../../Components/ViewPage'
import { TitleH1 } from '../../../../Components/CustomUi/titleH1'
import { TabelaFertilizantes } from './components/tabela'
import { Drawer } from 'antd'
import ButtonCustom from '../../../../Components/ButtonCustom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFloppyDisk, faXmark } from '@fortawesome/free-solid-svg-icons'
import { NavegacaoDrawer } from '../novoCompatibilidadeAtivo/components/gavetaCadastrar/styled'
import FormFertilizante from '../../../../Components/fertilizante'
import { usePostFertilizante, usePutFertilizante } from '../../../../services/fertilizante/POST'
import {
  useGetAplicacoes,
  useGetFertilizantes,
  useGetFertilizantesEditar,
  useGetFormulacao,
  useGetFuncoes,
  useGetMarca,
} from '../../../../services/fertilizante/GET'
import { useDeleteFertilizante } from '../../../../services/fertilizante/DELETE'
import { ItensPerUserLogged } from '../../../../services/login/permissaoUsuarioLoado'
import { getCulturas } from '../../../../services/cadastrarCultura'
import { v4 as uid } from 'uuid'
import { errorAlert, infoAlert } from '../../../../utils/alert'
import { ConfirmarFecharGaveta } from '../../patrimonioNovo/components/confirmarFecharGaveta'
import { verificarSeAlgoEstaPreenchido, verificarSeHouveAlteracoes } from './meta'

const Fertilizante: React.FC = () => {
    const totalRef = useRef<number | null>(null)

  //TABELA
  const [open, setOpen] = useState<boolean>(false)
  const [update, setUpdate] = useState<number>(null)
  const [updateDuplicar, setUpdateDuplicar] = useState<number>(null)
  const [pagination, setPagination] = useState<number>(15)
  const [page, setPage] = useState<number>(1)
  const [confirmar_exclusao, setConfirmar_exclusao] = useState<boolean>(false)
  const [id_item_atual, setId_item_atual] = useState<number>(null)
  const [nome_item_atual, setNome_item_atual] = useState<string>('')
  const [fake_loading, setFake_loading] = useState<boolean>(false)
  const [permissions, setPermissions] = useState<ItensPerUserLogged>()
  const [buscarTabela, setBuscarTabela] = useState('')
  const [filtradoAtivo, setFiltradoAtivo] = useState<boolean>(false)

  //FORMULARIO
  const [tab_selecionado_atual, setTab_selecionado_atual] = useState<
    'Dados do fertilizante' | 'Elementos' | 'Doses'
  >('Dados do fertilizante')
  const [nome, setNome] = useState<string>('')
  const [observacao, setObservacao] = useState<string>('')
  const [densidade, setDensidade] = useState<string>('')
  const [aminoacido, setAminoacido] = useState<string>('')
  const [indice_salino, setIndice_salino] = useState<string>('')
  const [formulacao, setFormulacao] = useState<string>('')
  const [formulacaoId, setFormulacaoId] = useState<number>(null)
  const [marca, setMarca] = useState<string>('')
  const [marcaId, setMarcaId] = useState<number>(null)
  const [extratoAlga, setExtratoAlga] = useState<string>('')
  const [extrato_de_alga_descricao, setExtrato_de_alga_descricao] = useState<string>('')
  const [solubilidade, setSolubilidade] = useState<string>('')
  const [concentracao_aminoacido, setConcentracao_aminoacido] = useState<string>('')
  const [descricao_aminoacido, setDescricao_aminoacido] = useState<string>('')
  const [concentracao_hormonio_regulador, setConcentracao_hormonio_regulador] = useState<string>('')
  const [descricao_hormonio_regulador, setDescricao_hormonio_regulador] = useState<string>('')
  const [concentracao_indutor_resistencia, setConcentracao_indutor_resistencia] =
    useState<string>('')
  const [descricao_indutor_resistencia, setDescricao_indutor_resistencia] = useState<string>('')
  const [concentracao_biologicos, setConcentracao_biologicos] = useState<string>('')
  const [descricao_biologicos, setDescricao_biologicos] = useState<string>('')
  const [ponto_deliquescencia, setPonto_deliquescencia] = useState<string>('')
  const [aplicacoes, setAplicacoes] = useState<{ descr: string; id: number; key?: number }[]>([])
  const [aplicacoesCopia, setAplicacoesCopia] = useState<
    { descr: string; id: number; key?: number }[]
  >([])
  const [funcao, setFuncao] = useState<{ descr: string; id: number; key?: number }[]>([])
  const [funcaoCopia, setFuncaoCopia] = useState<{ descr: string; id: number; key?: number }[]>([])
  const [aminoacidoPossuiDados, setAminoacidoPossuiDados] = useState<boolean>(false)
  const [hormonioReguladorPossuiDados, setHormonioReguladorPossuiDados] = useState<boolean>(false)
  const [indutorResistenciaPossuiDados, setIndutorResistenciaPossuiDados] = useState<boolean>(false)
  const [biologicosPosseuiDados, setBiologicosPosseuiDados] = useState<boolean>(false)
  const [extratoAlgaPossuiDados, setExtratoAlgaPossuiDados] = useState<boolean>(false)
  const [openPopover, setOpenPopover] = useState(false)
  const [dados_campos_originais, setDados_campos_originais] = useState({})

  //ELEMENTOS
  const [nitrogenio, setNitrogenio] = useState<string>('')
  const [fosforo, setFosforo] = useState<string>('')
  const [potassio, setPotassio] = useState<string>('')
  const [calcio, setCalcio] = useState<string>('')
  const [magnesio, setMagnesio] = useState<string>('')
  const [enxofre, setEnxofre] = useState<string>('')
  const [boro, setBoro] = useState<string>('')
  const [cobre, setCobre] = useState<string>('')
  const [ferro, setFerro] = useState<string>('')
  const [manganes, setManganes] = useState<string>('')
  const [zinco, setZinco] = useState<string>('')
  const [cobalto, setCobalto] = useState<string>('')
  const [molibdenio, setMolibdenio] = useState<string>('')
  const [niquel, setNiquel] = useState<string>('')
  const [silicio, setSilicio] = useState<string>('')
  const [selenio, setSelenio] = useState<string>('')

  //DOSES
  const [doseMax, setDoseMax] = useState<string>('')
  const [doseMin, setDoseMin] = useState<string>('')
  const [dosePadrao, setDosePadrao] = useState<string>('')
  const [cultura, setCultura] = useState<string>('')
  const [culturaId, setCulturaId] = useState<number>(null)
  const [doses, setDoses] = useState<
    {
      cod?: number | string
      cod_fertilizante?: number
      cultura_nome: string
      cod_cultura: number
      dose: string | number
      min_dose: string | number
      max_dose: string | number
    }[]
  >([])
  const [doses_remover, setDoses_remover] = useState<
    {
      cod?: number | string
      cod_cultura: number
      cod_fertilizante?: number
      dose: string | number
      min_dose: string | number
      max_dose: string | number
    }[]
  >([])
  const [dataCulturas, setDataCulturas] = useState([])
  const [editarDose, setEditarDose] = useState<boolean>(false)
  const [duplicarDose, setDuplicarDose] = useState<boolean>(false)
  const [cod_dose, setCod_dose] = useState<number>(null)
  const [confirmar_exclusao_dose, setConfirmar_exclusao_dose] = useState<boolean>(false)
  const [id_item_atual_dose, setId_item_atual_dose] = useState<number>(null)
  const [nome_item_atual_dose, setNome_item_atual_dose] = useState<string>('')
  const [fake_loading_dose, setFake_loading_dose] = useState<boolean>(false)
  const [total1, setTotal1] = useState(null)

  //APIS
  const { refetch_data_fertilizante, carregando_fertilizante, data_fertilizante } =
    useGetFertilizantes(pagination, page, buscarTabela )
  const {
    refetch_data_fertilizante_editar,
    carregando_fertilizante_editar,
    data_fertilizante_editar,
  } = useGetFertilizantesEditar(update ?? updateDuplicar)
  const { refetch_data_aplicacoes, data_aplicacoes } = useGetAplicacoes()
  const { refetch_data_funcoes, data_funcoes } = useGetFuncoes()
  const { refetch_data_formulacao, data_formulacao } = useGetFormulacao()
  const { refetch_data_marca, data_marca } = useGetMarca()
  const { carregando_salvar_fertilizante, mutate_fertilizante } = usePostFertilizante()
  const { mutate_edit_fertilizante, carregando_edit_fertilizante } = usePutFertilizante(update)
  const { mudateDeletarFertilizante } = useDeleteFertilizante()

  const gerarIdsUnicos = () => {
    const gerarIds = new Set()
    let id
    while (!id || gerarIds.has(id)) {
      id = Math.floor(Math.random() * 1000000)
    }
    gerarIds.add(id)
    return id
  }

  function abrirGaveta() {
    setOpen(true)
  }

  function editarGaveta(cod) {
    setOpen(true)
    setUpdate(cod)
  }

  function duplicar(cod) {
    setOpen(true)
    setUpdateDuplicar(cod)
  }

  function validarAlteracoes() {
    let campos_formulario = {
      nome: nome,
      observacao: observacao,
      densidade: densidade,
      aminoacido: concentracao_aminoacido,
      aminoacido_descricao: descricao_aminoacido,
      biologicos: concentracao_biologicos,
      biologicos_descricao: descricao_biologicos,
      hormonio_regulador: concentracao_hormonio_regulador,
      hormonio_regulador_descricao: descricao_hormonio_regulador,
      indutor_resistencia: concentracao_indutor_resistencia,
      indutor_resistencia_descricao: descricao_indutor_resistencia,
      solubilidade: solubilidade,
      ponto_deliquescencia: ponto_deliquescencia,
      culturas: doses,
      indice_salino: indice_salino,
      extrato_de_alga: extratoAlga,
      extrato_de_alga_descricao: extrato_de_alga_descricao,
      aplicacoes: aplicacoes.map((item) => item.id),
      funcoes: funcao.map((item) => item.id),
      cod_formulacao: formulacaoId,
      cod_marca: marcaId,
      n: nitrogenio,
      p: fosforo,
      k: potassio,
      ca: calcio,
      mg: magnesio,
      s: enxofre,
      b: boro,
      cu: cobre,
      fe: ferro,
      mn: manganes,
      zn: zinco,
      co: cobalto,
      mo: molibdenio,
      ni: niquel,
      si: silicio,
      se: selenio,
    }

    verificarSeHouveAlteracoes(
      dados_campos_originais,
      campos_formulario,
      setOpenPopover,
      fecharGaveta
    )
  }

  function verificarNovoCadastro() {
    const culturas = doses.map((item) => {
      return {
        cod_cultura: item.cod_cultura,
        dose: item.dose,
        min_dose: item.min_dose,
        max_dose: item.max_dose,
      }
    })
    let formulario = {
      nome: nome,
      observacao: observacao,
      densidade: densidade,
      aminoacido: concentracao_aminoacido,
      aminoacido_descricao: descricao_aminoacido,
      biologicos: concentracao_biologicos,
      biologicos_descricao: descricao_biologicos,
      hormonio_regulador: concentracao_hormonio_regulador,
      hormonio_regulador_descricao: descricao_hormonio_regulador,
      indutor_resistencia: concentracao_indutor_resistencia,
      indutor_resistencia_descricao: descricao_indutor_resistencia,
      solubilidade: solubilidade,
      ponto_deliquescencia: ponto_deliquescencia,
      culturas: culturas,
      indice_salino: indice_salino,
      extrato_de_alga: extratoAlga,
      extrato_de_alga_descricao: extrato_de_alga_descricao,
      aplicacoes: aplicacoes.map((item) => item.id),
      funcoes: funcao.map((item) => item.id),
      cod_formulacao: formulacaoId,
      cod_marca: marcaId,
      n: nitrogenio,
      p: fosforo,
      k: potassio,
      ca: calcio,
      mg: magnesio,
      s: enxofre,
      b: boro,
      cu: cobre,
      fe: ferro,
      mn: manganes,
      zn: zinco,
      co: cobalto,
      mo: molibdenio,
      ni: niquel,
      si: silicio,
      se: selenio,
    }
    verificarSeAlgoEstaPreenchido(formulario, setOpenPopover, fecharGaveta)
  }

  function fecharGaveta() {
    setOpen(false)
    setOpenPopover(false)
    setUpdate(null)
    setUpdateDuplicar(null)
    setNome('')
    setTab_selecionado_atual('Dados do fertilizante')
    setObservacao('')
    setDensidade('')
    setAminoacido('')
    setIndice_salino('')
    setAplicacoes([])
    setFuncao([])
    setDoses([])
    setDoses_remover([])
    setFormulacao('')
    setFormulacaoId(null)
    setMarca('')
    setMarcaId(null)
    setExtratoAlga('')
    setExtrato_de_alga_descricao('')
    setNitrogenio('')
    setFosforo('')
    setPotassio('')
    setCalcio('')
    setMagnesio('')
    setEnxofre('')
    setBoro('')
    setCobre('')
    setFerro('')
    setManganes('')
    setZinco('')
    setCobalto('')
    setMolibdenio('')
    setNiquel('')
    setSilicio('')
    setSelenio('')
    setSolubilidade('')
    setPonto_deliquescencia('')
    setConcentracao_aminoacido('')
    setDescricao_aminoacido('')
    setConcentracao_biologicos('')
    setDescricao_biologicos('')
    setConcentracao_hormonio_regulador('')
    setDescricao_hormonio_regulador('')
    setConcentracao_indutor_resistencia('')
    setDescricao_indutor_resistencia('')
    setCultura('')
    setCulturaId(null)
    setDoseMax('')
    setDoseMin('')
    setDosePadrao('')
    setAminoacidoPossuiDados(false)
    setExtratoAlgaPossuiDados(false)
    setBiologicosPosseuiDados(false)
    setIndutorResistenciaPossuiDados(false)
    setHormonioReguladorPossuiDados(false)
  }

  function salvarFertilizante() {
    const culturas = doses.map((item) => {
      return {
        cod_cultura: item.cod_cultura,
        dose: item.dose,
        min_dose: item.min_dose,
        max_dose: item.max_dose,
      }
    })

    if (update <= 0 || updateDuplicar > 0) {
      mutate_fertilizante({
        nome: nome,
        observacao: observacao,
        densidade: densidade,
        aminoacido: concentracao_aminoacido,
        aminoacido_descricao: descricao_aminoacido,
        biologicos: concentracao_biologicos,
        biologicos_descricao: descricao_biologicos,
        hormonio_regulador: concentracao_hormonio_regulador,
        hormonio_regulador_descricao: descricao_hormonio_regulador,
        indutor_resistencia: concentracao_indutor_resistencia,
        indutor_resistencia_descricao: descricao_indutor_resistencia,
        solubilidade: solubilidade,
        ponto_deliquescencia: ponto_deliquescencia,
        culturas: culturas,
        indice_salino: indice_salino,
        extrato_de_alga: extratoAlga,
        extrato_de_alga_descricao: extrato_de_alga_descricao,
        aplicacoes: aplicacoes.map((item) => item.id),
        funcoes: funcao.map((item) => item.id),
        cod_formulacao: formulacaoId,
        cod_marca: marcaId,
        n: nitrogenio,
        p: fosforo,
        k: potassio,
        ca: calcio,
        mg: magnesio,
        s: enxofre,
        b: boro,
        cu: cobre,
        fe: ferro,
        mn: manganes,
        zn: zinco,
        co: cobalto,
        mo: molibdenio,
        ni: niquel,
        si: silicio,
        se: selenio,
        refetch: () => {
          fecharGaveta()
          refetch_data_fertilizante()
        },
      })
    }

    if (update > 0) {
      const aplicacaoRemovidos = aplicacoesCopia.filter((id) => !aplicacoes.includes(id))
      const funcaoRemovidos = funcaoCopia.filter((id) => !funcao.includes(id))

      mutate_edit_fertilizante({
        nome: nome,
        observacao: observacao,
        densidade: densidade,
        aminoacido: concentracao_aminoacido,
        aminoacido_descricao: descricao_aminoacido,
        biologicos: concentracao_biologicos,
        biologicos_descricao: descricao_biologicos,
        hormonio_regulador: concentracao_hormonio_regulador,
        hormonio_regulador_descricao: descricao_hormonio_regulador,
        indutor_resistencia: concentracao_indutor_resistencia,
        indutor_resistencia_descricao: descricao_indutor_resistencia,
        solubilidade: solubilidade,
        ponto_deliquescencia: ponto_deliquescencia,
        culturas: culturas,
        culturas_remover: doses_remover,
        indice_salino: indice_salino,
        extrato_de_alga: extratoAlga,
        extrato_de_alga_descricao: extrato_de_alga_descricao,
        aplicacoes: aplicacoes.map((item) => item.id),
        aplicacoes_remover: aplicacaoRemovidos.map((item) => item.id),
        funcoes: funcao.map((item) => item.id),
        funcoes_remover: funcaoRemovidos.map((item) => item.id),
        cod_formulacao: formulacaoId,
        cod_marca: marcaId,
        n: nitrogenio,
        p: fosforo,
        k: potassio,
        ca: calcio,
        mg: magnesio,
        s: enxofre,
        b: boro,
        cu: cobre,
        fe: ferro,
        mn: manganes,
        zn: zinco,
        co: cobalto,
        mo: molibdenio,
        ni: niquel,
        si: silicio,
        se: selenio,
        refetch: () => {
          fecharGaveta()
          refetch_data_fertilizante()
        },
      })
    }
  }

  async function getCultura() {
    const resp = await getCulturas({ pagination: -1 })
    setDataCulturas(resp.data.itens)
  }

  function verificarCampos() {
    if (cultura === '' && culturaId === null) {
      return errorAlert('Selecione a cultura')
    }

    if (doseMax === '') {
      return errorAlert('Digite o valor da dose máxima')
    }

    if (doseMin === '') {
      return errorAlert('Digite o valor da dose mínima')
    }

    if (dosePadrao === '') {
      return errorAlert('Digite o valor da dose padrão')
    }

    return true
  }

  function inserirDosesCultura(cod) {
    if (doses.find((item) => item.cod_cultura === culturaId) && editarDose === false) {
      infoAlert('Informe outra cultura, cultura já adicionada!')
    } else if (verificarCampos()) {
      if (cod === null || duplicarDose) {
        setDoses((doses) => [
          ...doses,
          {
            cod: uid(),
            cod_cultura: culturaId,
            cultura_nome: cultura,
            max_dose: doseMax,
            min_dose: doseMin,
            dose: dosePadrao,
          },
        ])
        setCultura('')
        setCulturaId(null)
        setDoseMax('')
        setDoseMin('')
        setDosePadrao('')
        setDuplicarDose(false)
      } else {
        setDoses((prev) => {
          return prev.map((item) =>
            item.cod === cod
              ? {
                  ...item,
                  cod_cultura: culturaId,
                  cultura_nome: cultura,
                  max_dose: doseMax,
                  min_dose: doseMin,
                  dose: dosePadrao,
                }
              : item
          )
        })
        setCultura('')
        setCulturaId(null)
        setDoseMax('')
        setDoseMin('')
        setDosePadrao('')
        setEditarDose(false)
        setCod_dose(null)
      }
    }
  }

  function editarDoses(
    cod,
    cultura_nome,
    cod_cultura,
    dose_maxima,
    dose_minima,
    dose_padrao,
    duplicarEditar
  ) {
    if (duplicarEditar === 'editar') {
      setEditarDose(true)
      setCod_dose(cod)
      setCultura(cultura_nome)
      setCulturaId(cod_cultura)
      setDoseMax(dose_maxima)
      setDoseMin(dose_minima)
      setDosePadrao(dose_padrao)
    } else {
      setDuplicarDose(true)
      setCod_dose(cod)
      setDoseMax(dose_maxima)
      setDoseMin(dose_minima)
      setDosePadrao(dose_padrao)
    }
  }

  function deletarFertilizante(cod) {
    setFake_loading(true)
    mudateDeletarFertilizante({
      cod_fertilizante: cod,
      refetch_deletar: () => refetch_data_fertilizante(),
    })

    setTimeout(() => {
      setFake_loading(false)
    }, 800)
  }

  function deletarDoses(cod) {
    if (typeof cod === 'string') {
      setDoses((prevDoses) => prevDoses.filter((item) => item.cod !== cod))
    } else {
      setDoses((prevDados) => {
        let removidos = prevDados.find((item) => item.cod === cod)
        removidos.cod_fertilizante = update
        if (removidos) {
          setDoses_remover((prevRemovidos) => [...prevRemovidos, removidos])
        }
        return prevDados.filter((item) => item.cod !== cod)
      })
    }
  }

  function verificarConcentracoes(concentracao) {
    return concentracao && concentracao !== '0.00' ? true : false
  }

  function verificarDescricao(descricao) {
    return descricao !== null
  }

  useEffect(() => {
    refetch_data_fertilizante()
    refetch_data_aplicacoes()
    refetch_data_funcoes()
    refetch_data_formulacao()
    refetch_data_marca()
    getCultura()
  }, [])

  useEffect(() => {
    if (data_fertilizante_editar.length > 0 && (update > 0 || updateDuplicar > 0)) {
      setDados_campos_originais(data_fertilizante_editar[0])
      setNome(data_fertilizante_editar[0]?.nome)
      setDensidade(data_fertilizante_editar[0]?.densidade?.replace(/\./g, ','))
      setAminoacido(data_fertilizante_editar[0]?.aminoacido?.replace(/\./g, ','))
      setIndice_salino(data_fertilizante_editar[0]?.indice_salino?.replace(/\./g, ','))
      const editAplicacao = data_fertilizante_editar[0]?.aplicacoes.map((item) => {
        return { descr: item?.aplicacao_nome, id: item?.cod_aplicacao, key: item?.cod_aplicacao }
      })
      const editFuncoes = data_fertilizante_editar[0]?.funcoes?.map((item) => {
        return { descr: item?.nome, id: item?.cod, key: item?.cod }
      })
      setAplicacoes(editAplicacao)
      setAplicacoesCopia(editAplicacao)
      setFuncao(editFuncoes)
      setFuncaoCopia(editFuncoes)
      setFormulacao(data_fertilizante_editar[0]?.tipo_formulacao_nome)
      setFormulacaoId(data_fertilizante_editar[0]?.cod_formulacao)
      setMarca(data_fertilizante_editar[0]?.marca_nome)
      setMarcaId(data_fertilizante_editar[0]?.cod_marca)
      setObservacao(data_fertilizante_editar[0]?.observacao)
      setExtratoAlga(data_fertilizante_editar[0]?.extrato_de_alga?.replace(/\./g, ','))
      setExtrato_de_alga_descricao(data_fertilizante_editar[0]?.extrato_de_alga_descricao)
      setNitrogenio(data_fertilizante_editar[0]?.n?.replace(/\./g, ','))
      setFosforo(data_fertilizante_editar[0]?.p?.replace(/\./g, ','))
      setPotassio(data_fertilizante_editar[0]?.k?.replace(/\./g, ','))
      setCalcio(data_fertilizante_editar[0]?.ca?.replace(/\./g, ','))
      setMagnesio(data_fertilizante_editar[0]?.mg?.replace(/\./g, ','))
      setEnxofre(data_fertilizante_editar[0]?.s?.replace(/\./g, ','))
      setBoro(data_fertilizante_editar[0]?.b?.replace(/\./g, ','))
      setCobre(data_fertilizante_editar[0]?.cu?.replace(/\./g, ','))
      setFerro(data_fertilizante_editar[0]?.fe?.replace(/\./g, ','))
      setManganes(data_fertilizante_editar[0]?.mn?.replace(/\./g, ','))
      setZinco(data_fertilizante_editar[0]?.zn?.replace(/\./g, ','))
      setCobalto(data_fertilizante_editar[0]?.co?.replace(/\./g, ','))
      setMolibdenio(data_fertilizante_editar[0]?.mo?.replace(/\./g, ','))
      setNiquel(data_fertilizante_editar[0]?.ni?.replace(/\./g, ','))
      setSilicio(data_fertilizante_editar[0]?.si?.replace(/\./g, ','))
      setSelenio(data_fertilizante_editar[0]?.se?.replace(/\./g, ','))
      setConcentracao_aminoacido(data_fertilizante_editar[0]?.aminoacido?.replace(/\./g, ','))
      setDescricao_aminoacido(data_fertilizante_editar[0]?.aminoacido_descricao)
      setConcentracao_hormonio_regulador(
        data_fertilizante_editar[0]?.hormonio_regulador?.replace(/\./g, ',')
      )
      setDescricao_hormonio_regulador(data_fertilizante_editar[0]?.hormonio_regulador_descricao)
      setConcentracao_biologicos(data_fertilizante_editar[0]?.biologicos?.replace(/\./g, ','))
      setDescricao_biologicos(data_fertilizante_editar[0]?.biologicos_descricao)
      setConcentracao_indutor_resistencia(
        data_fertilizante_editar[0]?.indutor_resistencia?.replace(/\./g, ',')
      )
      setDescricao_indutor_resistencia(data_fertilizante_editar[0]?.indutor_resistencia_descricao)
      setSolubilidade(data_fertilizante_editar[0]?.solubilidade?.replace(/\./g, ','))
      setPonto_deliquescencia(
        data_fertilizante_editar[0]?.ponto_deliquescencia?.replace(/\./g, ',')
      )
      const culturas = data_fertilizante_editar[0]?.culturas.map((item) => {
        return {
          cod: gerarIdsUnicos(),
          cod_cultura: item?.cod,
          cultura_nome: item?.nome,
          dose: item?.dose,
          min_dose: item?.dose_minima,
          max_dose: item?.dose_maxima,
        }
      })
      setDoses(culturas)
    }

    if (update > 0) {
      setAminoacidoPossuiDados(
        verificarConcentracoes(data_fertilizante_editar[0]?.aminoacido) ||
          verificarDescricao(data_fertilizante_editar[0]?.aminoacido_descricao)
      )
      setHormonioReguladorPossuiDados(
        verificarConcentracoes(data_fertilizante_editar[0]?.hormonio_regulador) ||
          verificarDescricao(data_fertilizante_editar[0]?.hormonio_regulador_descricao)
      )
      setIndutorResistenciaPossuiDados(
        verificarConcentracoes(data_fertilizante_editar[0]?.indutor_resistencia) ||
          verificarDescricao(data_fertilizante_editar[0]?.indutor_resistencia_descricao)
      )
      setBiologicosPosseuiDados(
        verificarConcentracoes(data_fertilizante_editar[0]?.biologicos) ||
          verificarDescricao(data_fertilizante_editar[0]?.biologicos_descricao)
      )
      setExtratoAlgaPossuiDados(
        verificarConcentracoes(data_fertilizante_editar[0]?.extrato_de_alga) ||
          verificarDescricao(data_fertilizante_editar[0]?.extrato_de_alga_descricao)
      )
    }
  }, [data_fertilizante_editar])

  useEffect(() => {
    if (buscarTabela.length > 2) {
      setTimeout(() => {
        setFiltradoAtivo(true)
        refetch_data_fertilizante()
      }, 700)
    }
    if (buscarTabela === '') {
      setTimeout(() => {
        setFiltradoAtivo(false)
        refetch_data_fertilizante()
      }, 800)
    }
  }, [buscarTabela])

  useEffect(() => {
    if (update > 0) {
      refetch_data_fertilizante_editar()
    }
  }, [update])

  useEffect(() => {
    if (updateDuplicar > 0) {
      refetch_data_fertilizante_editar()
    }
  }, [updateDuplicar])

  useEffect(() => {
    refetch_data_fertilizante()
  }, [page])

  useEffect(() => {
    refetch_data_fertilizante()
  }, [pagination])

  useEffect(() => {
    
    if (filtradoAtivo === false) {
      setTotal1(data_fertilizante?.total)
    }
    
  }, [data_fertilizante?.total])

  useEffect(() => {
    if (
      (concentracao_aminoacido === '0,00' || concentracao_aminoacido === undefined) &&
      (descricao_aminoacido === '' || descricao_aminoacido === null)
    ) {
      setAminoacidoPossuiDados(false)
    }
  }, [concentracao_aminoacido, descricao_aminoacido])

  useEffect(() => {
    if (
      (concentracao_hormonio_regulador === '0,00' ||
        concentracao_hormonio_regulador === undefined) &&
      (descricao_hormonio_regulador === '' || descricao_hormonio_regulador === null)
    ) {
      setHormonioReguladorPossuiDados(false)
    }
  }, [concentracao_hormonio_regulador, descricao_hormonio_regulador])

  useEffect(() => {
    if (
      (concentracao_biologicos === '0,00' || concentracao_biologicos === undefined) &&
      (descricao_biologicos === '' || descricao_biologicos === null)
    ) {
      setBiologicosPosseuiDados(false)
    }
  }, [concentracao_biologicos, descricao_biologicos])

  useEffect(() => {
    if (
      (concentracao_indutor_resistencia === '0,00' ||
        concentracao_indutor_resistencia === undefined) &&
      (descricao_indutor_resistencia === '' || descricao_indutor_resistencia === null)
    ) {
      setIndutorResistenciaPossuiDados(false)
    }
  }, [concentracao_indutor_resistencia, descricao_indutor_resistencia])

  useEffect(() => {
    if (
      (extratoAlga === '0,00' || extratoAlga === undefined) &&
      (extrato_de_alga_descricao === '' || extrato_de_alga_descricao === null)
    ) {
      setExtratoAlgaPossuiDados(false)
    }
  }, [extratoAlga, extrato_de_alga_descricao])

  // useEffect(() => {
  //   if (update > 0 && ultimoCampo) {
  //     setTimeout(() => {
  //       switch (ultimoCampo) {
  //         case 'Observacao':
  //           observacaoRef.current?.focus()
  //           break
  //         case 'Formulacao':
  //           formulacaoRef.current?.focus()
  //           break
  //         case 'Marca':
  //           marcaRef.current?.focus()
  //           break
  //         case 'Funcao':
  //           funcaoRef.current?.focus()
  //           break
  //         default:
  //           break
  //       }
  //     }, 800) // pequeno delay para garantir que o Drawer montou
  //   }
  // }, [update, ultimoCampo])

  return (
    <ContainerFertilizante>
      <ViewPage
        rotina={88}
        onPermission={setPermissions}
        title='Fertilizantes'
        btnClick={null}
        hiddeTitle
        cardBodyStyle={{ padding: 15 }}
        cardMainStyle={{ height: '87.5vh' }}
      >
        <div style={{ marginBottom: '10px' }}>
          <TitleH1>Fertilizantes</TitleH1>
        </div>

        <TabelaFertilizantes
          abrirGaveta={abrirGaveta}
          listar_fertilizantes={data_fertilizante?.itens}
          loading={carregando_fertilizante}
          buscarTabela={buscarTabela}
          setBuscarTabela={setBuscarTabela}
          setPagination={setPagination}
          page={page}
          setPage={setPage}
          total={data_fertilizante?.total}
          permissao={permissions}
          editarCadastro={editarGaveta}
          duplicar={duplicar}
          deletar={deletarFertilizante}
          confirmar_exclusao={confirmar_exclusao}
          setConfirmar_exclusao={setConfirmar_exclusao}
          id_item_atual={id_item_atual}
          setId_item_atual={setId_item_atual}
          nome_item_atual={nome_item_atual}
          setNome_item_atual={setNome_item_atual}
          fake_loading={fake_loading}
          setFake_loading={setFake_loading}
          filtroAtivado={filtradoAtivo}
          setFiltroAtivado={setFiltradoAtivo}
          totalRef={total1}
        />
        <Drawer
          width={700}
          open={open}
          onClose={update <= 0 ? () => verificarNovoCadastro() : () => validarAlteracoes()}
          closable={false}
          bodyStyle={{ padding: 0 }}
          headerStyle={{ padding: '10px 10px' }}
          destroyOnClose
          footer={
            <div className='footer'>
              <ButtonCustom
                icon={<FontAwesomeIcon icon={faFloppyDisk} />}
                type='primary'
                onClick={salvarFertilizante}
                disabled={
                  carregando_salvar_fertilizante
                    ? carregando_salvar_fertilizante
                    : carregando_edit_fertilizante
                }
                loading={
                  carregando_salvar_fertilizante
                    ? carregando_salvar_fertilizante
                    : carregando_edit_fertilizante
                }
                hidden={permissions?.acesso === 1}
              >
                Salvar
              </ButtonCustom>
            </div>
          }
          title={
            <NavegacaoDrawer>
              <ButtonCustom
                danger
                icon={<FontAwesomeIcon icon={faXmark} />}
                type='tertiary'
                onClick={update <= 0 ? () => verificarNovoCadastro() : () => validarAlteracoes()}
                style={{ marginLeft: -10 }}
              >
                Fechar
              </ButtonCustom>
            </NavegacaoDrawer>
          }
        >
          <ConfirmarFecharGaveta
            title={`Você não salvou o cadastro!`}
            message='Deseja fechar sem salvar? Todas as informações inseridas serão perdidas.'
            openPopover={openPopover}
            setOpenPopover={setOpenPopover}
            onClose={fecharGaveta}
          />
          <FormFertilizante
            loadingForm={carregando_fertilizante_editar}
            update={update}
            tab_selecionar_atual={tab_selecionado_atual}
            setTab_selecionar_atual={setTab_selecionado_atual}
            nome={nome}
            setNome={setNome}
            observacao={observacao}
            setObservacao={setObservacao}
            extratoAlga={extratoAlga}
            setExtratoAlga={setExtratoAlga}
            extrato_de_alga_descricao={extrato_de_alga_descricao}
            setExtrato_de_alga_descricao={setExtrato_de_alga_descricao}
            densidade={densidade}
            setDensidade={setDensidade}
            aminoacido={aminoacido}
            setAminoacido={setAminoacido}
            indice_salino={indice_salino}
            setIndice_salino={setIndice_salino}
            aplicaçoes={aplicacoes}
            setAplicaçoes={setAplicacoes}
            funcao={funcao}
            setFuncao={setFuncao}
            formulacao={formulacao}
            setFormulacao={setFormulacao}
            setFormulacaoId={setFormulacaoId}
            marca={marca}
            setMarca={setMarca}
            setMarcaId={setMarcaId}
            nitrogenio={nitrogenio}
            setNitrogenio={setNitrogenio}
            fosforo={fosforo}
            setFosforo={setFosforo}
            potassio={potassio}
            setPotassio={setPotassio}
            calcio={calcio}
            setCalcio={setCalcio}
            magnesio={magnesio}
            setMagnesio={setMagnesio}
            enxofre={enxofre}
            setEnxofre={setEnxofre}
            boro={boro}
            setBoro={setBoro}
            cobre={cobre}
            setCobre={setCobre}
            ferro={ferro}
            setFerro={setFerro}
            manganes={manganes}
            setManganes={setManganes}
            zinco={zinco}
            setZinco={setZinco}
            cobalto={cobalto}
            setCobalto={setCobalto}
            molibdenio={molibdenio}
            setMolibdenio={setMolibdenio}
            niquel={niquel}
            setNiquel={setNiquel}
            silicio={silicio}
            setSilicio={setSilicio}
            selenio={selenio}
            setSelenio={setSelenio}
            data_aplicacoes={data_aplicacoes}
            data_funcoes={data_funcoes}
            data_formulacao={data_formulacao}
            data_marca={data_marca}
            solubilidade={solubilidade}
            setSolubilidade={setSolubilidade}
            concentracao_hormonio_regulador={concentracao_hormonio_regulador}
            setConcentracao_hormonio_regulador={setConcentracao_hormonio_regulador}
            descricao_hormonio_regulador={descricao_hormonio_regulador}
            setDescricao_hormonio_regulador={setDescricao_hormonio_regulador}
            concentracao_aminoacido={concentracao_aminoacido}
            setConcentracao_aminoacido={setConcentracao_aminoacido}
            descricao_aminoacido={descricao_aminoacido}
            setDescricao_aminoacido={setDescricao_aminoacido}
            concentracao_indutor_resistencia={concentracao_indutor_resistencia}
            setConcentracao_indutor_resistencia={setConcentracao_indutor_resistencia}
            descricao_indutor_resistencia={descricao_indutor_resistencia}
            setDescricao_indutor_resistencia={setDescricao_indutor_resistencia}
            concentracao_biologicos={concentracao_biologicos}
            setConcentracao_Biologicos={setConcentracao_biologicos}
            descricao_biologicos={descricao_biologicos}
            setDescricao_Biologicos={setDescricao_biologicos}
            ponto_deliquescencia={ponto_deliquescencia}
            setPonto_deliquescencia={setPonto_deliquescencia}
            doseMax={doseMax}
            setDoseMax={setDoseMax}
            doseMin={doseMin}
            setDoseMin={setDoseMin}
            dosePadrao={dosePadrao}
            setDosePadrao={setDosePadrao}
            cultura={cultura}
            setCultura={setCultura}
            culturaId={culturaId}
            setCulturaId={setCulturaId}
            dosagens={doses}
            data_cultura={dataCulturas}
            inserirDosesCultura={inserirDosesCultura}
            deletarDoses={deletarDoses}
            editarDoses={editarDoses}
            editar={editarDose}
            duplicar={duplicarDose}
            cod_dose={cod_dose}
            confirmar_exclusao={confirmar_exclusao_dose}
            setConfirmar_exclusao={setConfirmar_exclusao_dose}
            id_item_atual={id_item_atual_dose}
            setId_item_atual={setId_item_atual_dose}
            nome_item_atual={nome_item_atual_dose}
            setNome_item_atual={setNome_item_atual_dose}
            fake_loading={fake_loading_dose}
            setFake_loading={setFake_loading_dose}
            aminoacidoPossuiDados={aminoacidoPossuiDados}
            hormonioReguladorPossuiDados={hormonioReguladorPossuiDados}
            indutorResistenciaPossuiDados={indutorResistenciaPossuiDados}
            biologicosPosseuiDados={biologicosPosseuiDados}
            extratoAlgaPossuiDados={extratoAlgaPossuiDados}
          />
        </Drawer>
      </ViewPage>
    </ContainerFertilizante>
  )
}

export default Fertilizante
